import * as React from "react"
import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"

import Header from "./Header"
import Sections from "./Sections"
import { EmailPreferenceCenterTranslation } from "../../i18n"
import { Subscriptions, UpdateSubscriptions } from "../hooks/types"

export type PreferenceOperator = {
  subscriptionLists: Subscriptions
  updateSubscriptions: UpdateSubscriptions
}

type Props = {
  preferenceCenter: PreferenceCenter
  translation: EmailPreferenceCenterTranslation
  onUnsubscribe(): Promise<void>
  onSave(): Promise<void>
} & PreferenceOperator

const EmailPreferenceCenter: React.FC<Props> = ({
  preferenceCenter,
  subscriptionLists,
  translation,
  updateSubscriptions,
  onUnsubscribe,
  onSave,
}) => {
  const [saving, setSaving] = React.useState(false)
  const onSubmit = React.useCallback(
    (ev: React.FormEvent<HTMLFormElement>) => {
      ev.preventDefault()
      setSaving(true)
      onSave().finally(() => setSaving(false))
    },
    [preferenceCenter, onSave]
  )
  const onUnsubscribeClicked = React.useCallback(() => {
    setSaving(true)
    onUnsubscribe().finally(() => setSaving(false))
  }, [preferenceCenter, onUnsubscribe])

  return (
    <form onSubmit={onSubmit}>
      {preferenceCenter.display && <Header {...preferenceCenter.display} />}
      <a
        href="#skip_subscription-list"
        style={{ position: "absolute", height: 1, overflow: "hidden" }}
      >
        Skip subscription lists
      </a>
      <Sections
        sections={preferenceCenter.sections}
        subscriptionLists={subscriptionLists}
        updateSubscriptions={updateSubscriptions}
      />
      <div id="skip_subscription-list">
        <button className="save" type="submit" disabled={saving}>
          {translation.submitButtonText}
        </button>
        <button
          className="unsubscribe"
          onClick={onUnsubscribeClicked}
          disabled={saving}
        >
          {translation.unsubscribeButtonText}
        </button>
      </div>
    </form>
  )
}

export default EmailPreferenceCenter
